export const RATE_TIP_AUTO_OPEN_EVENT = "rate-tip:auto-open-trigger";
// Bắn sau khi gửi đánh giá/tip thành công để các màn đang mở (vd. kiểm đồ)
// tải lại order-detail và cập nhật số tiền tip.
export const RATE_TIP_SUBMITTED_EVENT = "rate-tip:submitted";
export const RATE_TIP_AUTO_OPEN_STORAGE_PREFIX = "rate-tip:auto-open";

export const RATE_TIP_TRIGGER_TYPES = {
  PAYMENT_REQUEST_SUCCESS: "payment-request-success",
};

export const RATE_TIP_TRIGGER_BY_ACTION = {
  paymentRequestSuccess: RATE_TIP_TRIGGER_TYPES.PAYMENT_REQUEST_SUCCESS,
};

export const emitRateTipAutoOpenTrigger = (trigger, extra = {}) => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(RATE_TIP_AUTO_OPEN_EVENT, {
      detail: {
        trigger,
        timestamp: Date.now(),
        ...extra,
      },
    }),
  );
};

export const emitRateTipAutoOpenTriggerByAction = (action, extra = {}) => {
  const trigger = RATE_TIP_TRIGGER_BY_ACTION[action];
  if (!trigger) return;

  emitRateTipAutoOpenTrigger(trigger, extra);
};

export const hasCustomerHandledMidMealTip = (qrCode) => {
  try {
    const raw = sessionStorage.getItem(
      `${RATE_TIP_AUTO_OPEN_STORAGE_PREFIX}:${qrCode || "unknown"}`,
    );
    if (!raw) return false;

    const state = JSON.parse(raw);
    return Boolean(state?.tipDeclined || state?.tipGiven);
  } catch (error) {
    return false;
  }
};

export const emitRateTipSubmitted = (extra = {}) => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(RATE_TIP_SUBMITTED_EVENT, { detail: extra }),
  );
};
